import type {
  PageTextCacheRecord,
  PageTextCacheRepository,
} from "@/domain";

import type { MarginaliaDatabase } from "./database";
import { toStorageWriteError } from "./storage-errors";

export class DexiePageTextCacheRepository
  implements PageTextCacheRepository
{
  constructor(private readonly db: MarginaliaDatabase) {}

  get(id: string): Promise<PageTextCacheRecord | undefined> {
    return this.db.pageTextCache.get(id);
  }

  async put(record: PageTextCacheRecord): Promise<void> {
    try {
      await this.db.pageTextCache.put(record);
    } catch (error) {
      throw toStorageWriteError(error, "cache extracted page text");
    }
  }

  async deleteForDocument(documentId: string): Promise<void> {
    try {
      await this.db.pageTextCache
        .where("documentId")
        .equals(documentId)
        .delete();
    } catch (error) {
      throw toStorageWriteError(error, "clear extracted page text");
    }
  }
}
